import { Pagination } from "react-bootstrap";
const PaginationComponent = ({ itemPerPage, totalItems, paginate, currentPage }) => {
    const pageNumbers = [];

    for (let i = 1; i <= Math.ceil(totalItems / itemPerPage); i++) {
        pageNumbers.push(i);
    }

    const paginationNumber = () => {
        if(pageNumbers.length <= 5){
            return pageNumbers;
        }else if(pageNumbers.length >= 5 && currentPage <= 4){
            return [1,2,3,4,5,'...',pageNumbers[pageNumbers.length - 1]];
        }else if(pageNumbers.length >= 5 && currentPage >= pageNumbers[pageNumbers.length - 4]){
            return [1,'...',pageNumbers[pageNumbers.length - 5],pageNumbers[pageNumbers.length - 4],pageNumbers[pageNumbers.length - 3],pageNumbers[pageNumbers.length - 2],pageNumbers[pageNumbers.length - 1]];
        }else if(pageNumbers.length > 5 && currentPage > 4 && currentPage < pageNumbers[pageNumbers.length - 4]){
            return [1,'...',currentPage-1,currentPage,currentPage+1,'...',pageNumbers[pageNumbers.length - 1]];
        }
    };

    let paginationItems = paginationNumber();

    const firstPage = () => {
        paginate(1);
    };

    const lastPage = () => {
        paginate(pageNumbers[pageNumbers.length - 1]);
    };

    const nextPage = () => {
        paginate(currentPage + 1);
    };

    const prevPage = () => {
        paginate(currentPage - 1);
    };

    return (
        <Pagination>
            <Pagination.First disabled={currentPage - 1 === 0} onClick={firstPage} />
            <Pagination.Prev disabled={currentPage - 1 === 0} onClick={prevPage}/>

            {paginationItems.map((item) => {
                return (
                    <Pagination.Item onClick={ev => paginate(item)}  disabled={isNaN(item)} className={`${currentPage === item ? "active" : ""}`} key={item}>
                        {item}
                    </Pagination.Item>
                );
            })}

            <Pagination.Next onClick={nextPage} />
            <Pagination.Last onClick={lastPage}/>
        </Pagination>
    );
};
export default PaginationComponent;
